// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emppoliciespage-inline-1 {
  text-align: center;
  color: #94a3b8;
  padding: 30px;
}

.emppoliciespage-inline-2 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpPoliciesPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".emppoliciespage-inline-1 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 30px;\n}\n\n.emppoliciespage-inline-2 {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
